import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './MartProductDetail.css'; // Create this for your custom styling

const MART_API_BASE = 'https://api.atrmart.in/martapi';

const MartProductDetail = ({ addToCart, cart, onLoginClick, user }) => {
  const { id } = useParams(); // Retrieves the product ID from the URL route
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchProductDetails = async () => {
      setLoading(true);
      try {
        // Fetch specific product by ID from your backend base URL
        const response = await axios.get(`${MART_API_BASE}/products/${id}`);
        
        // Handle varying backend structures safely
        const fetchedData = response.data?.data || response.data;
        
        if (fetchedData) {
          setProduct(fetchedData);
        } else {
          setError("Product not found in database.");
        }
      } catch (err) {
        console.error("Error fetching product details:", err);
        setError("Failed to fetch product information from the backend.");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchProductDetails();
    }
  } , [id]);

  // FIXED: Forces direct navigation back to the Mart landing dashboard, bypassing Agro completely
  const handleBackToMart = () => {
    navigate('/mart');
  };

  if (loading) {
    return (
      <div className="mart-loader-container">
        <div className="spinner-glow"></div>
        <span>Fetching Product Specifications...</span>
      </div>
    );
  }

  if (error || !product) {
    return (
      <div className="mart-error-container">
        <span className="error-emoji">⚠️</span>
        <p>{error || "Product configuration could not be loaded."}</p>
        <button className="error-back-btn" onClick={handleBackToMart}>
          Back to ATR Mart
        </button>
      </div>
    );
  }

  return (
    <div className="mart-product-detail-wrapper">
      {/* Back Button Layout */}
      <div className="detail-navigation-bar">
        <button className="mart-back-arrow-btn" onClick={handleBackToMart}>
          ← Back to Mart Dashboard
        </button>
      </div>

      <div className="mart-detail-container">
        {/* Left Aspect: Product Image Showcase */}
        <div className="mart-detail-image-panel">
          <img 
            src={product.image_url || 'https://via.placeholder.com/400'} 
            alt={product.name} 
            className="main-detail-img"
          />
        </div>

        {/* Right Aspect: Information Specification Panel */}
        <div className="mart-detail-info-panel">
          <span className="detail-category-tag">{product.category_name || 'Premium Item'}</span>
          <h1 className="detail-product-title">{product.name}</h1>
          
          <div className="detail-price-row">
            <span className="detail-current-price">₹{product.price}</span>
            {product.old_price && <span className="detail-old-price">₹{product.old_price}</span>}
          </div>

          <div className="detail-divider"></div>

          <div className="detail-description-section">
            <h3>Product Overview</h3>
            <p>{product.description || "No specific technical overview description provided for this catalog listing item."}</p>
          </div>

          <div className="detail-specs-list">
            {product.stock !== undefined && (
              <p><strong>Availability:</strong> {product.stock > 0 ? `${product.stock} Units In Stock` : 'Out of Stock'}</p>
            )}
            {product.brand && <p><strong>Brand/Manufacturer:</strong> {product.brand}</p>}
          </div>

          <div className="detail-actions-footer">
            <button 
              className="detail-add-to-cart-btn" 
              onClick={() => addToCart && addToCart(product)}
              disabled={product.stock === 0}
            >
              🛒 {product.stock === 0 ? 'Out of Stock' : 'Add to Shopping Cart'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MartProductDetail;